var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaInformacaoVermelho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08301 12.7499H10.9163V14.5833H9.08301V12.7499ZM9.08301 5.41658H10.9163V10.9166H9.08301V5.41658ZM9.99051 0.833252C4.93051 0.833252 0.833008 4.93992 0.833008 9.99992C0.833008 15.0599 4.93051 19.1666 9.99051 19.1666C15.0597 19.1666 19.1663 15.0599 19.1663 9.99992C19.1663 4.93992 15.0597 0.833252 9.99051 0.833252ZM9.99967 17.3333C5.94801 17.3333 2.66634 14.0516 2.66634 9.99992C2.66634 5.94825 5.94801 2.66659 9.99967 2.66659C14.0513 2.66659 17.333 5.94825 17.333 9.99992C17.333 14.0516 14.0513 17.3333 9.99967 17.3333Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaInformacaoVermelho);
export default __webpack_public_path__ + "static/media/alerta_informacao_vermelho.be011d72403ec30e4e80962b77528dba.svg";
export { ForwardRef as ReactComponent };